import createTableStore from "ds/components/Table/store/useTableStore";

import { STACK_WEBHOOKS_TABLE_COLUMNS_CONFIG, STACK_WEBHOOKS_TABLE_STORAGE_KEY } from "./constants";

const useStackWebhooksTableStore = createTableStore({
  storageKey: STACK_WEBHOOKS_TABLE_STORAGE_KEY,
  config: STACK_WEBHOOKS_TABLE_COLUMNS_CONFIG,
});

export default useStackWebhooksTableStore;
